import React from "react"
import Layout from "../../components/layout"
import { Col, Container, Row } from "react-bootstrap"
import Helmet from "react-helmet"
import CompanyTiles from "@/components/company/companyTiles"
import { CompanyWrapper } from "@/components/company/companyStyle"
import i1 from "@/images/z-27/1.png"
import i2 from "@/images/z-27/2.png"
import i3 from "@/images/z-27/3.png"
import i4 from "@/images/z-27/4.png"
import i5 from "@/images/z-27/5.png"


const Opinia = () => (
  <>
    <Helmet>
      <title>WILLBUD | Opinia</title>
    </Helmet>
    <Layout>
      <CompanyWrapper>
        <Container>
          <Row style={{ paddingBottom: "40px" }}>
            <Col>
              <h1 className="company-title">Opinia</h1>
              <h4 className="company-subtitle">
                Opinia naszych Klientów jest dla nas najważniejsza ponieważ dzięki niej możemy zwiększyć ich
                zadowolenie.
              </h4>
              <p className="company-content">
                Podziel się z nami swoimi doświadczeniami.
              </p>
              <hr />
              <p>
                Dla Ciebie to tylko minuta, ale dla nas to ogromna pomoc.
              </p>
              <p>
                Z góry dziękujemy,<br />
                Zespół WILLBUD
              </p>
            </Col>
            <Col xs={1} />
            <Col>
              <p style={{ marginTop: "52px" }}>
                <strong>Kliknij gwiazdki, aby nas ocenić:</strong>
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px", justifyContent: "space-between" }}>
                <div>
                  <a
                    href="https://www.google.com/maps/place//data=!4m3!3m2!1s0x46fda7351c396af7:0xc011e30a4d58fa1c!12e1"
                    target="_blank"
                  >
                    <img
                      alt="ocena 5"
                      border="0" width="220" height="46"
                      src={i5}
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.google.com/maps/place//data=!4m3!3m2!1s0x46fda7351c396af7:0xc011e30a4d58fa1c!12e1"
                    target="_blank"
                  >
                    <img
                      alt="ocena 4"
                      border="0" width="220" height="46"
                      src={i4}
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://public.trustindex.io/review_invite/support/slug/willbud.pl?rating=3&rrpid=test&lang=pl"
                    target="_blank"
                  >
                    <img
                      alt="ocena 3"
                      border="0" width="220" height="46"
                      src={i3}
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://public.trustindex.io/review_invite/support/slug/willbud.pl?rating=2&rrpid=test&lang=pl"
                    target="_blank"
                  >
                    <img
                      alt="ocena 2"
                      border="0" width="220" height="46"
                      src={i2}
                    />
                  </a>
                </div>
                <div>
                  <a
                    href="https://public.trustindex.io/review_invite/support/slug/willbud.pl?rating=1&rrpid=test&lang=pl"
                    target="_blank"
                  >
                    <img
                      alt="ocena 1"
                      border="0" width="220" height="46"
                      src={i1}
                    />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <CompanyTiles />
      </CompanyWrapper>
    </Layout>
  </>
)

export default Opinia
